import { css } from "styled-components";

// Try to use overflow-wrap, but include word-break for legacy
export const breakWordStyle = css`
  overflow-wrap: anywhere;
  word-break: break-word;
  hyphens: auto;
`;
